import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=315ac668&scoped=true&"
import script from "./MemberProfile.vue?vue&type=script&lang=ts&"
export * from "./MemberProfile.vue?vue&type=script&lang=ts&"
import style0 from "./MemberProfile.vue?vue&type=style&index=0&id=315ac668&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ac668",
  null
  
)

export default component.exports